import Vue from "vue";
import Vuetify from "vuetify/lib/framework";

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: "mdi",
  },
  theme: {
    fonts: {
      primary: "Noto Sans Arabic",
    },
    dark: false,
    themes: {
      dark: {
        background: "#C5C5C5",
      },
    },
  },
});
